import * as React from 'react'

import { CustomerContext } from './CustomerContext'

export const useCustomer = () => {
  return React.useContext(CustomerContext)
}
